import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=958361be&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"
import style0 from "./createRole.vue?vue&type=style&index=0&id=958361be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958361be",
  null
  
)

export default component.exports